// At most one request in flight and one trailing refresh for newer events.
export function coalescedRefresh(read) {
  let request = null
  let again = false
  let stopped = false
  return {
    run() {
      if (stopped) return Promise.resolve()
      if (request) { again = true; return request }
      request = (async () => {
        do {
          again = false
          await read()
        } while (again && !stopped)
      })().finally(() => { request = null })
      return request
    },
    stop() { stopped = true; again = false },
  }
}
